import { useEffect, useRef, useState } from "react";
import { Box, Flex, Paper, Title, Button, Stack, Text, Group } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import axios from "axios";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { BASE_API_CLIENT_URL } from "../../../config";

export default function ClearCache() {
  const [height, setHeight] = useState(0);
  const [loadingPrefix, setLoadingPrefix] = useState<string | null>(null);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (300 + headerHeight));
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClearCache = async (prefix: string, name: string) => {
    setLoadingPrefix(prefix);
    const apiUrl = `${BASE_API_CLIENT_URL}/Cache/delete-cache-prefix?prefix=${prefix}`;
    try {
      const res = await axios.get(apiUrl);

      if (res && (res.status === 200 || res.data?.success)) {
        NotificationExtension.Success(res.data?.message || `Xóa cache ${name} thành công!`);
      } else {
        NotificationExtension.Fails(res?.data?.message || `Xóa cache ${name} thất bại.`);
      }
    } catch (err: any) {
      console.error(err);
      const errMsg = err?.response?.data?.message || err?.message || `Đã xảy ra lỗi khi xóa cache ${name}.`;
      NotificationExtension.Fails(errMsg);
    } finally {
      setLoadingPrefix(null);
    }
  };

  return (
    <div
      style={{
        border: "1px solid #dee2e6",
        padding: 10,
        overflow: "hidden",
        height: height,
      }}
      ref={headerRef}
    >
      <Flex
        gap="md"
        justify="space-between"
        align="center"
        direction="row"
        wrap="wrap"
        w="100%"
      >
        <BreadCrumb />
      </Flex>

      <Flex mt={30} gap="xl" wrap="wrap">
        <Box style={{ width: 420 }}>
          <Paper shadow="xs" p="xl" withBorder>
            <Stack gap="md">
              <Title order={3}>Xóa Cache Hệ Thống</Title>
              <Text size="sm" c="dimmed">
                Xóa cache danh mục sản phẩm (Category) trên hệ thống website.
              </Text>
              <Text size="xs" c="gray.6" ff="monospace">
                Prefix: Hacom-api-web-Category-
              </Text>
              <Group justify="flex-start" mt="xs">
                <Button
                  leftSection={<IconTrash size={16} />}
                  color="red"
                  size="md"
                  loading={loadingPrefix === "Hacom-api-web-Category-"}
                  onClick={() => handleClearCache("Hacom-api-web-Category-", "hệ thống")}
                >
                  Xóa Cache
                </Button>
              </Group>
            </Stack>
          </Paper>
        </Box>

        <Box style={{ width: 420 }}>
          <Paper shadow="xs" p="xl" withBorder>
            <Stack gap="md">
              <Title order={3}>Xóa Cache Banner</Title>
              <Text size="sm" c="dimmed">
                Xóa cache danh sách banner hiển thị trên hệ thống website.
              </Text>
              <Text size="xs" c="gray.6" ff="monospace">
                Prefix: Hacom-api-web-TblBanner-
              </Text>
              <Group justify="flex-start" mt="xs">
                <Button
                  leftSection={<IconTrash size={16} />}
                  color="red"
                  size="md"
                  loading={loadingPrefix === "Hacom-api-web-TblBanner-"}
                  onClick={() => handleClearCache("Hacom-api-web-TblBanner-", "banner")}
                >
                  Xóa Cache Banner
                </Button>
              </Group>
            </Stack>
          </Paper>
        </Box>
      </Flex>
    </div>
  );
}
